import { render } from "./KategoriData.vue?vue&type=template&id=11689bf4"
import script from "./KategoriData.vue?vue&type=script&lang=js"
export * from "./KategoriData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__